var app = angular.module('tf.gamePopups', [])

    .controller('gamePopupsCtrl', ['$scope', '$uibModalInstance', '$window', function gamePopupsController($scope, $uibModalInstance, $window) {

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };



    }]);
